import { render, staticRenderFns } from "./InfractionNotices.vue?vue&type=template&id=712b9ee2&"
import script from "./InfractionNotices.vue?vue&type=script&lang=js&"
export * from "./InfractionNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports